import { createSlice } from "@reduxjs/toolkit";

const customerSlice = createSlice({
  name: "customer",
  initialState: {
    customerList: [],
    customerAllList: [],
    isFetching: false,
    isLoggedIn: false,
    error: false,
    totalPage: 0,
    totalItem: 0,
  },
  reducers: {
    getCustomer: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getCustomerSuccess: (state, action) => {
      state.isFetching = false;
      state.customerList = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getCustomerFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getAllCustomer: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getAllCustomerSuccess: (state, action) => {
      state.isFetching = false;
      state.customerAllList = action.payload.data
      state.error = false;
    },
    getAllCustomerFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    addCustomer: (state) => {
      state.isFetching = true
      state.error = false
    },
    addCustomerSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    addCustomerFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    updateCustomer: (state) => {
      state.isFetching = true
      state.error = false
    },
    updateCustomerSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    updateCustomerFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    removeCustomer: (state) => {
      state.isFetching = true
      state.error = false
    },
    removeCustomerSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    removeCustomerFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
  },
});

export const customerActions = customerSlice.actions;
export default customerSlice.reducer;
